export default __webpack_public_path__ + "static/media/MP_Skills_Salary_01.4a898d23.png";